export default __webpack_public_path__ + "static/image1-ad641604825aec21899743eeced0a371.png";